import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RegistryRequestModal({
  open,
  onClose,
  documentType = "IEC",
  documentLabel,
}) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const label = documentLabel || `${documentType} details`;

  const submit = async (event) => {
    event.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) {
      toast.error("Please enter your email.");
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(`${API}/iec-requests`, {
        email: normalizedEmail,
        document_type: documentType,
      });
      toast.success(`${documentType} request saved. Our export desk will respond by email.`);
      setEmail("");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || `Could not save ${documentType} request.`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="registry-request-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="registry-request-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="registry-request-title"
      >
        <button
          type="button"
          className="registry-request-close"
          aria-label="Close registry request form"
          onClick={onClose}
        >
          ×
        </button>
        <div className="registry-request-kicker">On request only</div>
        <h2 id="registry-request-title">Request the {label}.</h2>
        <p>
          Add your email and the export desk will share the registration details
          through a verified reply.
        </p>
        <form onSubmit={submit} className="registry-request-form">
          <label htmlFor="registry-request-email">Email address</label>
          <input
            id="registry-request-email"
            type="email"
            autoFocus
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="buyer@example.com"
          />
          <button type="submit" disabled={submitting}>
            {submitting ? "Saving..." : "Submit Request"}
          </button>
        </form>
      </div>
    </div>
  );
}
